// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #0a0a0a;
}

::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Hide scrollbar for episode navigation */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Utility classes for Tailwind-like styling */
.min-h-screen {
  min-height: 100vh;
}

.bg-black {
  background-color: #000;
}

.text-white {
  color: #fff;
}

.font-sans {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

/* Sticky header */
.sticky {
  position: sticky;
}

.top-0 {
  top: 0;
}

.z-30 {
  z-index: 30;
}

.backdrop-blur-md {
  backdrop-filter: blur(12px);
}

.border-b {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Flexbox utilities */
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

/* Grid */
.grid {
  display: grid;
}

.gap-8 {
  gap: 2rem;
}

/* Padding and margin */
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

/* Text utilities */
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.uppercase {
  text-transform: uppercase;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.tracking-wide {
  letter-spacing: 0.025em;
}

.leading-tight {
  line-height: 1.25;
}

/* Rounded corners */
.rounded-full {
  border-radius: 9999px;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

/* Borders */
.border {
  border-width: 1px;
}

/* Backgrounds */
.bg-white\\/5 {
  background-color: rgba(255, 255, 255, 0.05);
}

.bg-white\\/10 {
  background-color: rgba(255, 255, 255, 0.1);
}

.bg-white\\/15 {
  background-color: rgba(255, 255, 255, 0.15);
}

.bg-black\\/20 {
  background-color: rgba(0, 0, 0, 0.2);
}

.bg-black\\/70 {
  background-color: rgba(0, 0, 0, 0.7);
}

.border-white\\/10 {
  border-color: rgba(255, 255, 255, 0.1);
}

.border-white\\/15 {
  border-color: rgba(255, 255, 255, 0.15);
}

.border-white\\/25 {
  border-color: rgba(255, 255, 255, 0.25);
}

/* Text colors with opacity */
.text-white\\/50 {
  color: rgba(255, 255, 255, 0.5);
}

.text-white\\/60 {
  color: rgba(255, 255, 255, 0.6);
}

.text-white\\/70 {
  color: rgba(255, 255, 255, 0.7);
}

.text-white\\/80 {
  color: rgba(255, 255, 255, 0.8);
}

.text-white\\/85 {
  color: rgba(255, 255, 255, 0.85);
}

/* Shadows */
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* Transitions */
.transition {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* Hover effects */
button:hover {
  cursor: pointer;
}

/* Whitespace */
.whitespace-nowrap {
  white-space: nowrap;
}

/* Overflow */
.overflow-x-auto {
  overflow-x: auto;
}

/* Flex utilities */
.flex-1 {
  flex: 1 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.flex-wrap {
  flex-wrap: wrap;
}

/* Max width */
.max-w-3xl {
  max-width: 48rem;
}

.max-w-4xl {
  max-width: 56rem;
}

.max-w-5xl {
  max-width: 64rem;
}

.max-w-6xl {
  max-width: 72rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

/* Space utilities */
.space-y-2 > * + * {
  margin-top: 0.5rem;
}

/* List styles */
ul {
  list-style: none;
}

/* Inline utilities */
.inline-block {
  display: inline-block;
}

.inline-flex {
  display: inline-flex;
}

/* Gradient text */
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.from-emerald-300 {
  --tw-gradient-from: #6ee7b7;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(110, 231, 183, 0));
}

.via-sky-300 {
  --tw-gradient-stops: var(--tw-gradient-from), #7dd3fc, var(--tw-gradient-to, rgba(125, 211, 252, 0));
}

.to-fuchsia-300 {
  --tw-gradient-to: #f0abfc;
}

.bg-clip-text {
  -webkit-background-clip: text;
  background-clip: text;
}

.text-transparent {
  color: transparent;
}

/* Gradient backgrounds for episodes */
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.from-purple-700 {
  --tw-gradient-from: #7e22ce;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(126, 34, 206, 0));
}

.via-purple-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #581c87, var(--tw-gradient-to, rgba(88, 28, 135, 0));
}

.from-amber-700 {
  --tw-gradient-from: #b45309;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(180, 83, 9, 0));
}

.via-orange-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #7c2d12, var(--tw-gradient-to, rgba(124, 45, 18, 0));
}

.from-pink-700 {
  --tw-gradient-from: #be185d;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(190, 24, 93, 0));
}

.via-rose-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #881337, var(--tw-gradient-to, rgba(136, 19, 55, 0));
}

.from-sky-700 {
  --tw-gradient-from: #0369a1;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(3, 105, 161, 0));
}

.via-sky-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #0c4a6e, var(--tw-gradient-to, rgba(12, 74, 110, 0));
}

.from-orange-700 {
  --tw-gradient-from: #c2410c;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(194, 65, 12, 0));
}

.via-red-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #7f1d1d, var(--tw-gradient-to, rgba(127, 29, 29, 0));
}

.from-yellow-700 {
  --tw-gradient-from: #a16207;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(161, 98, 7, 0));
}

.via-amber-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #78350f, var(--tw-gradient-to, rgba(120, 53, 15, 0));
}

.from-indigo-700 {
  --tw-gradient-from: #4338ca;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(67, 56, 202, 0));
}

.via-indigo-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #312e81, var(--tw-gradient-to, rgba(49, 46, 129, 0));
}

.from-cyan-700 {
  --tw-gradient-from: #0e7490;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(14, 116, 144, 0));
}

.via-teal-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #134e4a, var(--tw-gradient-to, rgba(19, 78, 74, 0));
}

.from-emerald-700 {
  --tw-gradient-from: #047857;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(4, 120, 87, 0));
}

.via-green-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #14532d, var(--tw-gradient-to, rgba(20, 83, 45, 0));
}

.from-blue-700 {
  --tw-gradient-from: #1d4ed8;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(29, 78, 216, 0));
}

.via-blue-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #1e3a8a, var(--tw-gradient-to, rgba(30, 58, 138, 0));
}

.from-lime-700 {
  --tw-gradient-from: #4d7c0f;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(77, 124, 15, 0));
}

.via-lime-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #365314, var(--tw-gradient-to, rgba(54, 83, 20, 0));
}

.from-violet-700 {
  --tw-gradient-from: #6d28d9;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(109, 40, 217, 0));
}

.from-red-700 {
  --tw-gradient-from: #b91c1c;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(185, 28, 28, 0));
}

.from-slate-700 {
  --tw-gradient-from: #334155;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(51, 65, 85, 0));
}

.via-slate-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #0f172a, var(--tw-gradient-to, rgba(15, 23, 42, 0));
}

.from-fuchsia-700 {
  --tw-gradient-from: #a21caf;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(162, 28, 175, 0));
}

.via-fuchsia-900 {
  --tw-gradient-stops: var(--tw-gradient-from), #701a75, var(--tw-gradient-to, rgba(112, 26, 117, 0));
}

.to-black {
  --tw-gradient-to: #000;
}

.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}

.from-black {
  --tw-gradient-from: #000;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(0, 0, 0, 0));
}

.via-slate-950 {
  --tw-gradient-stops: var(--tw-gradient-from), #020617, var(--tw-gradient-to, rgba(2, 6, 23, 0));
}

.to-slate-900 {
  --tw-gradient-to: #0f172a;
}

/* Bullet points */
.h-1\\.5 {
  height: 0.375rem;
}

.w-1\\.5 {
  width: 0.375rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.bg-white\\/70 {
  background-color: rgba(255, 255, 255, 0.7);
}

.bg-white\\/60 {
  background-color: rgba(255, 255, 255, 0.6);
}

.bg-emerald-300 {
  background-color: #6ee7b7;
}

/* Responsive */
@media (min-width: 640px) {
  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

/* Letter spacing */
.tracking-\\[0\\.25em\\] {
  letter-spacing: 0.25em;
}

.tracking-\\[0\\.35em\\] {
  letter-spacing: 0.35em;
}

/* Text alignment */
.text-center {
  text-align: center;
}

/* Max width */
.max-w-2xl {
  max-width: 42rem;
}

/* Padding */
.p-5 {
  padding: 1.25rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

/* Custom text sizes */
.text-\\[11px\\] {
  font-size: 11px;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

/* Min height */
.min-h-\\[80vh\\] {
  min-height: 80vh;
}

.min-h-\\[60vh\\] {
  min-height: 60vh;
}
`, "",{"version":3,"sources":["webpack://./src/AppEpisodic.css"],"names":[],"mappings":"AAEA;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0DAA0D;EAC1D,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0DAA0D;AAC5D;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,mFAAmF;AACrF;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,SAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,qEAAqE;AACvE;;AAEA;EACE,2BAA2B;EAC3B,2FAA2F;AAC7F;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,4EAA4E;AAC9E;;AAEA;EACE,2BAA2B;EAC3B,0FAA0F;AAC5F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,0FAA0F;AAC5F;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,2BAA2B;EAC3B,0FAA0F;AAC5F;;AAEA;EACE,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,2BAA2B;EAC3B,0FAA0F;AAC5F;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,wBAAwB;EACxB,qFAAqF;AACvF;;AAEA;EACE,+FAA+F;AACjG;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\n/* Smooth scroll behavior */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0a0a0a;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #333;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Hide scrollbar for episode navigation */\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.no-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n/* Utility classes for Tailwind-like styling */\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.bg-black {\n  background-color: #000;\n}\n\n.text-white {\n  color: #fff;\n}\n\n.font-sans {\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n}\n\n/* Sticky header */\n.sticky {\n  position: sticky;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.z-30 {\n  z-index: 30;\n}\n\n.backdrop-blur-md {\n  backdrop-filter: blur(12px);\n}\n\n.border-b {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Flexbox utilities */\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.gap-3 {\n  gap: 0.75rem;\n}\n\n/* Grid */\n.grid {\n  display: grid;\n}\n\n.gap-8 {\n  gap: 2rem;\n}\n\n/* Padding and margin */\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem;\n}\n\n.mb-8 {\n  margin-bottom: 2rem;\n}\n\n.mt-10 {\n  margin-top: 2.5rem;\n}\n\n/* Text utilities */\n.text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.tracking-wide {\n  letter-spacing: 0.025em;\n}\n\n.leading-tight {\n  line-height: 1.25;\n}\n\n/* Rounded corners */\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-3xl {\n  border-radius: 1.5rem;\n}\n\n/* Borders */\n.border {\n  border-width: 1px;\n}\n\n/* Backgrounds */\n.bg-white\\/5 {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.bg-white\\/10 {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.bg-white\\/15 {\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.bg-black\\/20 {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.bg-black\\/70 {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n\n.border-white\\/10 {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.border-white\\/15 {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.border-white\\/25 {\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n/* Text colors with opacity */\n.text-white\\/50 {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.text-white\\/60 {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.text-white\\/70 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.text-white\\/80 {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.text-white\\/85 {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* Shadows */\n.shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n/* Transitions */\n.transition {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n/* Hover effects */\nbutton:hover {\n  cursor: pointer;\n}\n\n/* Whitespace */\n.whitespace-nowrap {\n  white-space: nowrap;\n}\n\n/* Overflow */\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n/* Flex utilities */\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n/* Max width */\n.max-w-3xl {\n  max-width: 48rem;\n}\n\n.max-w-4xl {\n  max-width: 56rem;\n}\n\n.max-w-5xl {\n  max-width: 64rem;\n}\n\n.max-w-6xl {\n  max-width: 72rem;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Space utilities */\n.space-y-2 > * + * {\n  margin-top: 0.5rem;\n}\n\n/* List styles */\nul {\n  list-style: none;\n}\n\n/* Inline utilities */\n.inline-block {\n  display: inline-block;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n/* Gradient text */\n.bg-gradient-to-r {\n  background-image: linear-gradient(to right, var(--tw-gradient-stops));\n}\n\n.from-emerald-300 {\n  --tw-gradient-from: #6ee7b7;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(110, 231, 183, 0));\n}\n\n.via-sky-300 {\n  --tw-gradient-stops: var(--tw-gradient-from), #7dd3fc, var(--tw-gradient-to, rgba(125, 211, 252, 0));\n}\n\n.to-fuchsia-300 {\n  --tw-gradient-to: #f0abfc;\n}\n\n.bg-clip-text {\n  -webkit-background-clip: text;\n  background-clip: text;\n}\n\n.text-transparent {\n  color: transparent;\n}\n\n/* Gradient backgrounds for episodes */\n.bg-gradient-to-br {\n  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));\n}\n\n.from-purple-700 {\n  --tw-gradient-from: #7e22ce;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(126, 34, 206, 0));\n}\n\n.via-purple-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #581c87, var(--tw-gradient-to, rgba(88, 28, 135, 0));\n}\n\n.from-amber-700 {\n  --tw-gradient-from: #b45309;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(180, 83, 9, 0));\n}\n\n.via-orange-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #7c2d12, var(--tw-gradient-to, rgba(124, 45, 18, 0));\n}\n\n.from-pink-700 {\n  --tw-gradient-from: #be185d;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(190, 24, 93, 0));\n}\n\n.via-rose-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #881337, var(--tw-gradient-to, rgba(136, 19, 55, 0));\n}\n\n.from-sky-700 {\n  --tw-gradient-from: #0369a1;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(3, 105, 161, 0));\n}\n\n.via-sky-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #0c4a6e, var(--tw-gradient-to, rgba(12, 74, 110, 0));\n}\n\n.from-orange-700 {\n  --tw-gradient-from: #c2410c;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(194, 65, 12, 0));\n}\n\n.via-red-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #7f1d1d, var(--tw-gradient-to, rgba(127, 29, 29, 0));\n}\n\n.from-yellow-700 {\n  --tw-gradient-from: #a16207;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(161, 98, 7, 0));\n}\n\n.via-amber-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #78350f, var(--tw-gradient-to, rgba(120, 53, 15, 0));\n}\n\n.from-indigo-700 {\n  --tw-gradient-from: #4338ca;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(67, 56, 202, 0));\n}\n\n.via-indigo-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #312e81, var(--tw-gradient-to, rgba(49, 46, 129, 0));\n}\n\n.from-cyan-700 {\n  --tw-gradient-from: #0e7490;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(14, 116, 144, 0));\n}\n\n.via-teal-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #134e4a, var(--tw-gradient-to, rgba(19, 78, 74, 0));\n}\n\n.from-emerald-700 {\n  --tw-gradient-from: #047857;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(4, 120, 87, 0));\n}\n\n.via-green-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #14532d, var(--tw-gradient-to, rgba(20, 83, 45, 0));\n}\n\n.from-blue-700 {\n  --tw-gradient-from: #1d4ed8;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(29, 78, 216, 0));\n}\n\n.via-blue-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #1e3a8a, var(--tw-gradient-to, rgba(30, 58, 138, 0));\n}\n\n.from-lime-700 {\n  --tw-gradient-from: #4d7c0f;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(77, 124, 15, 0));\n}\n\n.via-lime-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #365314, var(--tw-gradient-to, rgba(54, 83, 20, 0));\n}\n\n.from-violet-700 {\n  --tw-gradient-from: #6d28d9;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(109, 40, 217, 0));\n}\n\n.from-red-700 {\n  --tw-gradient-from: #b91c1c;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(185, 28, 28, 0));\n}\n\n.from-slate-700 {\n  --tw-gradient-from: #334155;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(51, 65, 85, 0));\n}\n\n.via-slate-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #0f172a, var(--tw-gradient-to, rgba(15, 23, 42, 0));\n}\n\n.from-fuchsia-700 {\n  --tw-gradient-from: #a21caf;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(162, 28, 175, 0));\n}\n\n.via-fuchsia-900 {\n  --tw-gradient-stops: var(--tw-gradient-from), #701a75, var(--tw-gradient-to, rgba(112, 26, 117, 0));\n}\n\n.to-black {\n  --tw-gradient-to: #000;\n}\n\n.bg-gradient-to-b {\n  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));\n}\n\n.bg-gradient-to-t {\n  background-image: linear-gradient(to top, var(--tw-gradient-stops));\n}\n\n.from-black {\n  --tw-gradient-from: #000;\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(0, 0, 0, 0));\n}\n\n.via-slate-950 {\n  --tw-gradient-stops: var(--tw-gradient-from), #020617, var(--tw-gradient-to, rgba(2, 6, 23, 0));\n}\n\n.to-slate-900 {\n  --tw-gradient-to: #0f172a;\n}\n\n/* Bullet points */\n.h-1\\.5 {\n  height: 0.375rem;\n}\n\n.w-1\\.5 {\n  width: 0.375rem;\n}\n\n.mt-1 {\n  margin-top: 0.25rem;\n}\n\n.bg-white\\/70 {\n  background-color: rgba(255, 255, 255, 0.7);\n}\n\n.bg-white\\/60 {\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.bg-emerald-300 {\n  background-color: #6ee7b7;\n}\n\n/* Responsive */\n@media (min-width: 640px) {\n  .sm\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .sm\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .sm\\:text-sm {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n\n  .sm\\:text-base {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n\n  .sm\\:text-lg {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n  }\n\n  .sm\\:text-4xl {\n    font-size: 2.25rem;\n    line-height: 2.5rem;\n  }\n\n  .sm\\:text-5xl {\n    font-size: 3rem;\n    line-height: 1;\n  }\n\n  .sm\\:flex-row {\n    flex-direction: row;\n  }\n\n  .sm\\:items-center {\n    align-items: center;\n  }\n\n  .sm\\:justify-between {\n    justify-content: space-between;\n  }\n\n  .sm\\:gap-3 {\n    gap: 0.75rem;\n  }\n\n  .sm\\:flex-none {\n    flex: none;\n  }\n\n  .sm\\:p-6 {\n    padding: 1.5rem;\n  }\n\n  .sm\\:text-xs {\n    font-size: 0.75rem;\n    line-height: 1rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n\n  .lg\\:text-5xl {\n    font-size: 3rem;\n    line-height: 1;\n  }\n\n  .lg\\:text-6xl {\n    font-size: 3.75rem;\n    line-height: 1;\n  }\n\n  .lg\\:text-lg {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n  }\n}\n\n/* Letter spacing */\n.tracking-\\[0\\.25em\\] {\n  letter-spacing: 0.25em;\n}\n\n.tracking-\\[0\\.35em\\] {\n  letter-spacing: 0.35em;\n}\n\n/* Text alignment */\n.text-center {\n  text-align: center;\n}\n\n/* Max width */\n.max-w-2xl {\n  max-width: 42rem;\n}\n\n/* Padding */\n.p-5 {\n  padding: 1.25rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.py-1\\.5 {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n}\n\n/* Custom text sizes */\n.text-\\[11px\\] {\n  font-size: 11px;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.text-4xl {\n  font-size: 2.25rem;\n  line-height: 2.5rem;\n}\n\n/* Min height */\n.min-h-\\[80vh\\] {\n  min-height: 80vh;\n}\n\n.min-h-\\[60vh\\] {\n  min-height: 60vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
